'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var helpQuestionComponent = exports.helpQuestionComponent = {
    template: '<a ui-sref="helpDetail({ categoryId: vm.question.categoryId, subCategoryId: vm.question.subCategoryId, questionId: vm.question.questionId})">{{vm.question.question}}</a>',
    bindings: {
        question: '<'
    },
    controllerAs: 'vm',
    controller: function controller() {
        var vm = this;
        vm.$onInit = init;

        function init() {}
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/common/help-question.js
// module id = 918
// module chunks = 0